// Copyright (c) 2021, DIALPAD INC., all rights reserved.

import React from 'react';
import onClickOutside from 'react-onclickoutside';
import {
    MdFlashOn,
    MdPhone,
    MdAttachFile,
    MdRecordVoiceOver,
    MdSentimentSatisfied,
    MdShowChart,
} from 'react-icons/md';
import {ShortText, Image, Videocam, Textsms, Document} from '@app/common/icons';
import {SmartButtonIcon} from './smart_button';
import {npsEnabled} from '@app/utils/dom';

interface AddBlockWidgetActionsProps {
    hideActions?: any;
    addNewExtensionBlock?: any;
    addNewHandoverBlock?: any;
    addNewCTABlock?: any;
    addNewAttachmentBlock?: any;
    addNewTextBlock?: any;
    addNewImageBlock?: any;
    addNewVideoBlock?: any;
    addNewQuoteBlock?: any;
    addNewChoicesBlock?: any;
    addNewNPSBlock?: any;
    addNewCSATBlock?: any;
    addNewCESBlock?: any;
}

// Handles the Modal creation Dropdown for the different block fields.
/* TODO(joaonoronha): Re-evaluate components responsibility, needs a refactor,
 * also there's a possibility of making this a completely dynamic component.
 */
export class AddBlockWidgetActionsComponent extends React.Component<AddBlockWidgetActionsProps> {
    blockFactory = (callbacks) => {
        return (e) => {
            e.preventDefault();
            e.stopPropagation();
            for (let i = 0; i < callbacks.length; i++) {
                callbacks[i]();
            }
        };
    };

    handleClickOutside() {
        const {hideActions} = this.props;
        hideActions();
    }

    handleClickAddNewExtensionBlock = this.blockFactory([
        this.props.addNewExtensionBlock,
        this.props.hideActions,
    ]);

    handleClickAddNewHandoverBlock = this.blockFactory([
        this.props.addNewHandoverBlock,
        this.props.hideActions,
    ]);

    handleClickAddNewCTABlock = this.blockFactory([
        this.props.addNewCTABlock,
        this.props.hideActions,
    ]);

    handleClickAddNewAttachmentBlock = this.blockFactory([
        this.props.addNewAttachmentBlock,
        this.props.hideActions,
    ]);

    handleClickAddNewTextBlock = this.blockFactory([
        this.props.addNewTextBlock,
        this.props.hideActions,
    ]);

    handleClickAddNewImageBlock = this.blockFactory([
        this.props.addNewImageBlock,
        this.props.hideActions,
    ]);

    handleClickAddNewVideoBlock = this.blockFactory([
        this.props.addNewVideoBlock,
        this.props.hideActions,
    ]);

    handleClickAddNewQuoteBlock = this.blockFactory([
        this.props.addNewQuoteBlock,
        this.props.hideActions,
    ]);

    handleClickAddNewChoicesBlock = this.blockFactory([
        this.props.addNewChoicesBlock,
        this.props.hideActions,
    ]);

    handleClickAddNewNPSBlock = this.blockFactory([
        this.props.addNewNPSBlock,
        this.props.hideActions,
    ]);

    handleClickAddNewCSATBlock = this.blockFactory([
        this.props.addNewCSATBlock,
        this.props.hideActions,
    ]);

    handleClickAddNewCESBlock = this.blockFactory([
        this.props.addNewCESBlock,
        this.props.hideActions,
    ]);

    render() {
        const iconSize = 15;
        return (
            <section className="add-block-widget-actions">
                <span className="add-block-widget-subsection">CONTENT</span>
                <div onClick={this.handleClickAddNewTextBlock}>
                    <ShortText size={iconSize} /> Text
                </div>
                <div onClick={this.handleClickAddNewQuoteBlock}>
                    <Document /> Attach content
                </div>
                <div onClick={this.handleClickAddNewImageBlock}>
                    <Image size={iconSize} />
                    Image
                </div>
                <div onClick={this.handleClickAddNewVideoBlock}>
                    <Videocam size={iconSize} /> Video
                </div>
                <div onClick={this.handleClickAddNewAttachmentBlock}>
                    <MdAttachFile size={iconSize} /> Attach files
                </div>
                <span className="add-block-widget-subsection">NAVIGATION</span>
                <div onClick={this.handleClickAddNewChoicesBlock}>
                    <Textsms size={iconSize} /> Create dialog
                </div>
                <span className="add-block-widget-subsection">
                    GOAL COMPLETION
                </span>
                <div onClick={this.handleClickAddNewCTABlock}>
                    <SmartButtonIcon size={iconSize} /> Call to action
                </div>
                <div onClick={this.handleClickAddNewHandoverBlock}>
                    <MdPhone size={iconSize} /> Handover
                </div>
                <div onClick={this.handleClickAddNewExtensionBlock}>
                    <MdFlashOn size={iconSize} /> Action
                </div>
                <span className="add-block-widget-subsection">CX METRICS</span>
                {npsEnabled() && (
                    <div onClick={this.handleClickAddNewNPSBlock}>
                        <MdRecordVoiceOver size={iconSize} /> NPS&reg;
                    </div>
                )}
                <div onClick={this.handleClickAddNewCSATBlock}>
                    <MdSentimentSatisfied size={iconSize} /> CSAT
                </div>
                <div onClick={this.handleClickAddNewCESBlock}>
                    <MdShowChart size={iconSize} /> CES
                </div>
            </section>
        );
    }
}

export const AddBlockWidgetActions = onClickOutside(
    AddBlockWidgetActionsComponent,
);
